/*
 * @Author: 陶慧灵
 * @Date: 2022-10-21 09:20:20
 * @LastEditors: wenbei421 346972930@qq.com
 * @LastEditTime: 2022-10-25 15:08:19
 * @Descripttion:
 * @FilePath: \src\index-examine.ts
 */
import icsChromelyRequest from '@icreate/ics-chromely-js-sdk'
import IndexExamine from './index-examine'
import { escapeSpecialCharacters } from './utils'

export default class DictIndex {
  private static like = ['ID', 'NAME', 'SPELL_CODE', 'STROKE_CODE']
  private static exact = {}

  /**
   *
   * @param category：分类,例如DICT_SEX、DICT_NATION
   * @param keys：关键字
   * @param exact：精确匹配字段和值 精确匹配字段和值 { type : 1 }
   * @returns 成功返回结果
   */
  public static query(
    category: string | Array<string>,
    keys: string = '',
    exact: {
      [key: string]: string
    } | null = null
  ): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      if (Array.isArray(category)) return IndexExamine.query('DictionaryIndex', category, '')
      else
        return IndexExamine.query(
          'DictionaryIndex',
          category,
          this.QueryCondition(category, escapeSpecialCharacters(keys), exact)
        )
    } else {
      return IndexExamine.queryByServer('DictionaryIndex', category, keys, this.like, exact || {})
    }
  }

  /**
   * 分页查询索引
   * @param indexId: 索引id
   * @param pageIndex：page索引
   * @param pageSize：page尺寸
   * @param category：分类,例如DICT_SEX、DICT_NATION
   * @param keys：关键字
   * @param exact：精确匹配字段和值 { type : 1 }
   * @returns 成功返回结果
   */
  public static page(
    pageIndex: number,
    pageSize: number,
    category: string,
    keys: string = '',
    exact: {
      [key: string]: string
    } | null = null
  ): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.page(
        'DictionaryIndex',
        pageIndex,
        pageSize,
        category,
        this.QueryCondition(category, escapeSpecialCharacters(keys), exact)
      )
    } else {
      return IndexExamine.pageByServer(
        'DictionaryIndex',
        pageIndex,
        pageSize,
        category,
        keys,
        this.like,
        exact || {}
      )
    }
  }

  /**
   * 查询条件组装
   * @param keys
   * @returns
   */
  private static QueryCondition(
    category: string,
    keys: string,
    exact: {
      [key: string]: string
    } | null
  ): string {
    // return `(id:*${keys}* OR name:"*${keys}*" OR spellCode:*${keys}* OR strokeCode:*${keys}*)`
    let condition = []
    if (keys.trim()) {
      condition.push(
        `(id:*${keys}* OR name:"*${keys}*" OR spellCode:*${keys}* OR strokeCode:*${keys}*)`
      )
    }
    if (exact) {
      Object.keys(exact).forEach(key => {
        condition.push(`${key}:${exact[key]}`)
      })
    }
    return condition.join(' AND ')
  }
}
